import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";


export default function TopBarChart({title, data, clickFunction}){
	
	
	const thisContainer = {
		display:'flex',
		width:"100%",
		flexDirection:"column"
	};
	
	const titleContainer = {
		display:"flex",
		height:"30px",
		alignItems:'center',
		fontSize:'16px',
		color:'white',
		justifyContent:"space-around",
		cursor:"pointer"
	};
	
	const chartContainer = {
		display:"flex",
		width:"100%",
		flexDirection:"column",
		marginTop:"10px"
	};
	
	const chartRow = {
		display:"flex",
		width:"100%",
		height:"30px",
		alignItems:"center"
	};
	
	const chartCategory = {
		display:'flex',
		width:"150px",
		color:"white",
		fontSize:"12px"
	};
	
	const barContainer = {
		display:"flex",
		flexGrow:"1"
	};
	
	const bar = {
		display:"flex",
		height:"6px",
		borderRadius:"3px",
		backgroundColor:"white"
	};
	
	const chartLabel = {
		display:'flex',
		width:"200px",
		color:"white",
		fontSize:"12px",
		width:"50px",
		flexDirection:"row-reverse"
	};
	
	const handleClick = {
		if(clickFunction){
			clickFunction();
		}
	};
	
	const iconStyle = {
		display:"flex",
		width:"15px",
		height:"15px",
		color:'white',
		marginRight:"10px",
		cursor:"hand"
	};
	
	const dataDisplay = data.map((item, index) => 
		<div style={chartRow}>
			<FontAwesomeIcon icon="info-circle" style={iconStyle} onClick={handleClick}/>
			<div style={chartCategory}>
				{item.category}
			</div>
			<div style={barContainer}>
				<div style={{...bar, width:item.percentage}}/>
			</div>
			<div style={chartLabel}>
				{item.label}
			</div>	
		</div>
	);
	
	return (
		<div style={thisContainer}>
			<div style={titleContainer}>
				{title}
			</div>
			<div style={chartContainer}>
				{dataDisplay}
			</div>
		</div>
	);
}